import EnrolmentsAdapter from './base';

export default class Ping extends EnrolmentsAdapter {
  modelNamePlural = 'pings';
}
